import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

import '@fortawesome/fontawesome-free/css/all.min.css';

import vModal from 'vue-js-modal';
import VueGtag from 'vue-gtag';

import api from './services/api';

import RNG from './utils/RNG';
import RouteParser from './utils/RouteParser';

import Pagination from 'jw-vue-pagination';
import infiniteScroll from 'vue-infinite-scroll';

import Toasted from 'vue-toasted';
import vGallery from 'v-gallery';
import FlagIcon from 'vue-flag-icon'; // Flags

import Zendesk from '@dansmaculotte/vue-zendesk';
import ICS from 'vue-ics';

import checkenter from './directives/checkenter';

Vue.directive('checkenter', checkenter);

import moment from 'moment';

Vue.prototype.moment = moment;
moment.locale('pt-br');

Vue.directive('swipe', {
  bind: function (el, binding, vnode) {
    const touchPoint = {
      x: null,
      y: null,
    };

    const emit = (v) => {
      binding.value(v);
    };

    el.touchStartHandler = (e) => {
      e.preventDefault();
      touchPoint.x = e.touches[0].clientX;
      touchPoint.y = e.touches[0].clientY;
    };
    el.touchMoveHandler = (e) => {
      e.stopPropagation();
      if (!touchPoint.x || !touchPoint.y) return;
      let xDiff = touchPoint.x - e.touches[0].clientX;
      let yDiff = touchPoint.y - e.touches[0].clientY;
      if (Math.abs(xDiff) < 25 && Math.abs(yDiff) < 25) {
        return;
      }

      if (Math.abs(xDiff) >= Math.abs(yDiff)) {
        if (xDiff > 0) emit('right');
        else emit('left');
      } else {
        if (yDiff > 0) emit('bottom');
        else emit('top');
      }

      touchPoint.x = null;
      touchPoint.y = null;
    };

    el.addEventListener('touchstart', el.touchStartHandler);
    el.addEventListener('touchmove', el.touchMoveHandler);
  },
  unbind: function (el) {
    el.removeEventListener('touchstart', el.touchStartHandler);
    el.removeEventListener('touchmove', el.touchMoveHandler);
  },
});

const RNG_plugin = {
  install() {
    Vue.RNG = RNG;
    Vue.prototype.$RNG = RNG;
  },
};
Vue.use(RNG_plugin);

const RouteParser_plugin = {
  install() {
    Vue.RouteParser = RouteParser;
    Vue.prototype.$RouteParser = RouteParser;
  },
};

Vue.use(RouteParser_plugin);

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt-br';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/external/elementui.scss';

Vue.use(ElementUI, { locale });

Vue.use(Toasted, {
  router,
});

Vue.use(vGallery);

Vue.component('pagination', Pagination);

Vue.use(infiniteScroll);

Vue.config.ignoredElements = [/^ion-/]; // ion icons

Vue.use(FlagIcon);

Vue.use(ICS);

Vue.use(vModal, { componentName: 'modals-container', dynamic: true, dialog: true });

Vue.config.productionTip = false;

//import Amplify from 'aws-amplify';
//import aws_exports from './aws-exports';
//Amplify.configure(aws_exports);

//import {
//  applyPolyfills,
//  defineCustomElements,
//} from '@aws-amplify/ui-components/loader';

//applyPolyfills().then(() => {
//   defineCustomElements(window);
// });
function generateManifest(event_info) {
  let myDynamicManifest = {
    name: event_info.title,
    short_name: event_info.title,
    description: event_info.eventDisclaimer,
    start_url: window.location.protocol + '//' + window.location.host,
    background_color: event_info.colors.mainColor,
    theme_color: event_info.colors.secondaryColor,
    display: 'standalone',
    scope: window.location.protocol + '//' + window.location.host,
    icons: [
      {
        src: event_info.favicon192 ? event_info.favicon192 : event_info.favicon,
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: event_info.favicon512 ? event_info.favicon512 : event_info.favicon,
        sizes: '512x512',
        type: 'image/png',
      },
    ],
  };

  // appending modified manifest href value to index.html
  const stringManifest = JSON.stringify(myDynamicManifest);
  const blob = new Blob([stringManifest], { type: 'application/json' });
  const manifestURL = URL.createObjectURL(blob);
  document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);

  document.querySelector('#my-apple-touch-icon-placeholder').setAttribute('href', event_info.faviconApple ? event_info.faviconApple : event_info.favicon);
  document.querySelector('#my-icon32').setAttribute('href', event_info.favicon32 ? event_info.favicon32 : event_info.favicon);
  document.querySelector('#my-icon16').setAttribute('href', event_info.favicon16 ? event_info.favicon16 : event_info.favicon);

  document.querySelector('#my-meta-description').setAttribute('content', event_info.eventDisclaimer);

  document.querySelector('#my-meta-theme-color-placeholder').setAttribute('content', event_info.colors.mainColor);
}

api
  .get(`home/${document.location.hostname == 'localhost' || document.location.hostname.indexOf('192.168') >= 0 ? 'testbug.blitzar.com.br' : document.location.hostname}`)
  .then((response) => {
    // console.log('MAIN get referrer: ', JSON.stringify(document.referrer));

    store.commit('setTemplate', response.data);
    store.commit('setEvent', response.data);

    let configuration = JSON.parse(response.data.config);
    // console.log('GA: ' + configuration.gaConfig);
    // api.get(`event/${response.data.event_id}/menu`)
    //   .then((response) => {
    //     // console.log('Menu =', response.data);
    //     store.commit("setMenu", response.data);
    //   }).catch((err) => {
    //     console.error(err);
    //   });

    // api.get(`event/${response.data.event_id}/agenda`)
    //   .then((response) => {
    //     // console.log('Agenda =', response.data);
    //     store.commit("setAgenda", response.data);
    //   }).catch((err) => {
    //     console.error(err);
    //   });

    // ZENDESK
    if (configuration.zendeskConfig) {
      let userLanguage = store.state.user.language ? store.state.user.language.toLowerCase() : 'pt';

      if (store.state.template.multilanguagesConfig) {
        configuration.accessConfig = configuration.accessConfig[`accessConfig_${userLanguage}`];
        // console.log('configuration.accessConfig ' + JSON.stringify(configuration.accessConfig))
      }

      Vue.use(Zendesk, {
        key: configuration.zendeskConfig, //'7b39575c-4d23-4746-80ba-ddffc5a1db1c',
        disabled: false,
        hideOnLoad: false,
        settings: {
          webWidget: {
            offset: { horizontal: '-10px', vertical: '18px' },
            color: {
              theme: `${configuration.accessConfig.zendeskColor ? configuration.accessConfig.zendeskColor : '#FFFFFF'}`,
            },
            label: {
              '*': `${configuration.accessConfig.zendeskLabel ? configuration.accessConfig.zendeskLabel : 'Precisa de ajuda?'}`,
            },
            chatLabel: {
              '*': `${configuration.accessConfig.zendeskChatLabel ? configuration.accessConfig.zendeskChatLabel : 'Posso ajudar?'}`,
            },
          },
          launcher: {
            chatLabel: {
              '*': `${configuration.accessConfig.zendeskChatLabelLauncher ? configuration.accessConfig.zendeskChatLabelLauncher : 'Suporte'}`,
            },
          },
        },
      });
    }

    // LINKEDIN
    if (configuration.linkedinConfig) {
      let linkedinId = document.createElement('script');
      linkedinId.type = 'text/javascript';
      linkedinId.text = ` _linkedin_partner_id = "${configuration.linkedinConfig}";
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);`;
      document.body.appendChild(linkedinId);

      let linkedinIdScript = document.createElement('script');
      linkedinIdScript.type = 'text/javascript';
      linkedinIdScript.async = true;
      linkedinIdScript.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      document.body.appendChild(linkedinIdScript);
    }

    // FACEBOOK
    if (configuration.facebookConfig) {
      // console.log('Facebook config:', configuration.facebookConfig)
      let meta = document.createElement('meta');
      meta.setAttribute('name', 'facebook-domain-verification');
      meta.setAttribute('content', configuration.facebookConfig);
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    // FACEBOOK PIXEL
    if (configuration.facebookConfig) {
      let fbPixelScript = document.createElement('script');
      fbPixelScript.type = 'text/javascript';
      fbPixelScript.async = true;
      fbPixelScript.text = `!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', ${configuration.facebookConfig});
          fbq('track', 'PageView');`;
      document.body.appendChild(fbPixelScript);
    }

    Vue.use(VueGtag, { config: { id: configuration.gaConfig } }, router);

    generateManifest(configuration);

    new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch((err) => {
    console.error(err);
  });
